// #region Imports

import * as $ from "jquery";

// #endregion Imports

// #region Exports

export function initialize(): void {
   wireStickyDocumentTools();
}

// #endregion Exports

// #region Private members

let $docHeader: any;
let $docHeaderContainer: any;
let $docHeaderRightContainer: any;
let $docHeaderLeftContainer: any;
let $contentTogglerMenu: any;
let $xmlDocument: any;


// #endregion Private members

// #region Private functions

function wireStickyDocumentTools(): void {

    $docHeader = $('.js-sticky-document-header');
    if ($docHeader.length === 0) {
        return;
    }

    $docHeaderContainer = $docHeader.parent();
    $docHeaderRightContainer = $('.document-sticky__document-header-right');
    $docHeaderLeftContainer = $('.document-sticky__document-header-left');
    $contentTogglerMenu = $('.document-sticky__content-toggler-menu');       
    $xmlDocument = $('.xml_document');           
 }

// #endregion Private functions